<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-divider></v-divider>
    </v-flex>
    <v-flex xs12 md4 class="text-xs-left">
      Sessões: <strong>{{ training.sessions }}</strong>
    </v-flex>
    <v-flex xs12 md4 class="text-xs-left">
      Nível: <strong>{{ training.level }}</strong>
    </v-flex>
    <v-spacer></v-spacer>
    <v-flex xs12 v-if="training.description">
      Descrição: <strong>{{ training.description }}</strong>
    </v-flex>

    <v-flex xs12>
      <div width="100%">
        <div class="v-table__overflow">
          <table class="v-datatable v-table theme--light" width="100%">
            <thead>
              <tr>
                <th scope="col" class="column text-xs-left">Exercícios</th>
                <th scope="col" width="80" class="column">Séries</th>
                <th scope="col" width="80" class="column">Repetições</th>
                <th scope="col" width="80" class="column">Carga</th>
                <th scope="col" width="80" class="column">Intervalo</th>
                <th scope="col" width="80" class="column">Intensidade</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in training.exercises" :key="index">
                <td class="text-xs-left">
                  <a href="javascript:void(0);" v-modal-trigger="'showUserExercise'" :data-item="JSON.stringify(item)">
                    {{ item.name }}
                  </a>
                </td>
                <td class="text-xs-center">
                  {{ item.series }}
                </td>
                <td class="text-xs-center">
                  {{ item.repetitions }}
                </td>
                <td class="text-xs-center">
                  {{ item.weight }}
                </td>
                <td class="text-xs-center">
                  {{ item.interval }}
                </td>
                <td class="text-xs-center">
                  {{ item.amplitude }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['training']
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/userShow/AdminUserShowTrainingItem.vue